import api from "@/api/anomaly/anomaly-events";

const getAnomalyEvents = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .getAnomalyEvents(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });

export default { getAnomalyEvents };
